<template>
  <div>
    <b-button
      type="button"
      :class="btnClass"
      @click="handleToggle"
      :disabled="disabled"
      size="sm"
      :title="''"
    >
      <i class="fad fa-toggle-on" v-if="isOpen"></i>
      <i class="fad fa-toggle-off" v-else-if="isClosed"></i>
      {{ btnTitle }}
    </b-button>
  </div>
</template>

<script>
import tr from 'vue2-datepicker/locale/es/tr'

export default {
  data() {
    return {
      isLoading: false
    }
  },
  props: ['table', 'isTableClosed'],
  methods: {
    handleToggle() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      let url = null
      let message = null
      if (this.isClosed) {
        url = '/api/v1/tables/' + this.table.tableId + '/openHand'
        message = 'Table opened'
      } else {
        url = '/api/v1/tables/' + this.table.tableId + '/closeHand'
        message = 'Table closed'
      }

      this.$http({
        url: url,
        method: 'PUT'
      })
        .then(resp => {
          this.$toastr.i(message)
          this.$emit('finish', resp.data)
        })
        .catch(err => {
          this.$toastr.e(JSON.stringify(err.response.data.message))

          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  computed: {
    tr() {
      return tr
    },
    btnClass() {
      return this.isClosed ? 'btn btn-danger btn-xs' : 'btn btn-success btn-xs'
    },
    btnTitle() {
      return this.isClosed ? 'Closed' : 'Open'
    },
    isOpen() {
      return !this.isClosed
    },
    isClosed() {
      return this.isTableClosed[this.table.tableId] === 'closed'
    },
    disabled() {
      return this.isLoading
    }
  }
}
</script>
